import { render } from "./PrizesGallery.vue?vue&type=template&id=c60046a4&scoped=true"
import script from "./PrizesGallery.vue?vue&type=script&lang=js"
export * from "./PrizesGallery.vue?vue&type=script&lang=js"

import "./PrizesGallery.vue?vue&type=style&index=0&id=c60046a4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60046a4"]])

export default __exports__